import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    nameOfProductionBusinessActivities,
    addressWard,
    addressDistrict,
    addressCity,
    address,
    addressEstate,
    addressCityEstate,
    addressDistrictEstate,
    addressWardEstate,
    contract,
    contractDate,
    notarizedDate,
    taxAgentName,
    taxAgentId,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [nameOfProductionBusinessActivities.name]: "",
  [addressWard.name]: "",
  [addressDistrict.name]: "",
  [addressCity.name]: "",
  [address.name]: "",
  [addressEstate.name]: "",
  [addressCityEstate.name]: "",
  [addressDistrictEstate.name]: "",
  [addressWardEstate.name]: "",
  [contract.name]: "",
  [contractDate.name]: "",
  [notarizedDate.name]: "",
  [taxAgentId.name]: "",
};

export default initialValues;
